import path from 'path';
import imageExtensions from 'image-extensions';

import { LOC_STORAGE_APP_STATE_KEY } from 'shared/constants/web';
import { makeLocalObjStore } from './localObjStoreFactory';

export const appStateStore = makeLocalObjStore(LOC_STORAGE_APP_STATE_KEY);


export const noop = () => {};
export const yolo = () => { alert('yolo!'); };
export const isFunc = (x) => (typeof x === 'function');
export const isObject = value => (
  value !== null && typeof value === 'object'
);


/*
 * Quick and dirty way to remove target keys using JSON.stringify.
 * Apparently not very efficient so use it responsively.
 *
 * References:
 * https://stackoverflow.com/a/39461077/3479934
 * https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify
 */
export const omitDeep = (obj, keys = []) => {
  if (typeof obj !== 'object' || !keys.length) {
    return obj;
  }

  const replacer = (k, v) => (keys.includes(k) ? undefined : v);
  return JSON.parse(JSON.stringify(obj, replacer));
};


/*
 * Loosely validate a URL `string`.
 *
 * Reference: github.com/segmentio/is-url
 */
// eslint-disable-next-line
const urlMatcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
export const isUrl = string => urlMatcher.test(string);


/*
 * isImage
 *
 * Ref: https://github.com/sindresorhus/is-image/
 */
const imgExts = new Set(imageExtensions);
export const isImage = (filepath) => {
  const ext = path.extname(filepath).slice(1).toLowerCase();
  return imgExts.has(ext);
};


export const isProdEnv = process.env.NODE_ENV === 'production';


export const formatModuleId = ({
  platform,  // {web|ios|android|electron}
  publisher = 'moagraph',
  moduleName,
  version,
}) => (
  `${platform}.${publisher}.${moduleName}.${version}`
);


// Expect a list of errors with [{ key, message } ...] structure
export const extractFirstErrorMessage = (errors, key) => {
  if (!Array.isArray(errors)) {
    return null;
  }

  const { message } = errors.filter(e => (
    key ? (key === e.key) : true
  ))[0] || {};

  if (typeof message !== 'string') {
    return null;
  }

  return message;
};


export const isEmptyArray = (thing) => {
  return (Array.isArray(thing) && thing.length === 0);
};


export const isValidJsonStr = (str) => {
  try {
    return (JSON.parse(str) && !!str);
  } catch (e) {
    return false;
  }
};


/*
 * timeoutPromiseAt
 *
 * Reference:
 * https://italonascimento.github.io/applying-a-timeout-to-your-promises/
 */
export const timeoutPromiseAt = function(ms, promise) {
  // Create a promise that rejects in <ms> milliseconds
  const timeout = new Promise((resolve, reject) => {
    const id = setTimeout(() => {
      clearTimeout(id);
      reject('Timed out in '+ ms + 'ms. Please try again later.');
    }, ms);
  });

  // Returns a race between our timeout and the passed in promise
  return Promise.race([promise, timeout]);
};


/*
 * Measure browser viewport
 */
// https://stackoverflow.com/a/8876069/3479934
export const viewportWidth = () => (
  Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  )
);
export const viewportHeight = () => (
  Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  )
);

export const isInsideViewport = (elem) => {
  // Reference: https://stackoverflow.com/a/5354536/3479934
  const rect = elem.getBoundingClientRect();
  const viewHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  );
  const isInside = !(
    rect.bottom < 0
    || rect.top - viewHeight >= 0
  );

  return isInside;
};


export const getSelectionBoundingRect = () => {
  if (!window) {
    return null;
  }

  const selection = window.getSelection();
  if (selection.rangeCount === 0) {
    return null;
  }

  const range = selection.getRangeAt(0);
  const rect = range.getBoundingClientRect();
  return rect;
};


export { keycodeFromEvent } from './keycode';
export {
  RxSubjRegistrar,
  makeFuncDebounceSwitchMapViaRxSubj,
} from './rxHelper';
export { uniqueId } from './uniqueId';
export { debounce } from './debounce';
export { compose } from './compose';
export { cloneChildrenRecursively } from './reactHelper';
export { default as processError } from './processError';
export { default as jwtStore, decodeJwt } from './jwtStore';
export { default as oauthStore } from './oauthStore';
export { default as hljsDetectLanguage } from './hljsDetectLanguage';
export { default as loadPrismLangs } from './loadPrismLangs';
export { getFirstQueryNameOf } from './gqlHelper';



// WEBPACK FOOTER //
// ./src/shared/helpers/index.js